import React from 'react';
import { Box, Typography } from '@mui/material';

const Disclaimer = () => {
  return (
    <Box
      sx={{
        width: '100%',
        mt: 6,
        py: 2,
        backgroundColor: 'transparent',
        
      }}
    >
      <Typography
        variant="h7"
        sx={{
          mx: 'auto',
          maxWidth: '900px', // larghezza massima del testo, puoi modificarla
          textAlign: 'center'
        }}
      >

        <strong>EU AI Act:</strong> Contenuto generato da AI a rischio limitato (Reg. UE sull'Intelligenza Artificiale). <br/>Non sostituisce il parere di un professionista sanitario.
        <br />
        Il testo di output non è utilizzabile a fini diagnostici.
        <br />
        Ricorda in ogni caso di consultare lo specialista di riferimento che, con un esame clinico completo, può indirizzarti al percorso terapeutico indicato.
        
      </Typography>
    </Box>
  );
};

export default Disclaimer;
